// Minimal SVG sparkline. No charting dependency — the drawer only needs a
// small historical-trend cue next to the projected-impact numbers.

import {FC} from "react";

interface SparklineProps {
    points: number[];
    width?: number;
    height?: number;
    stroke?: string;
}

export const Sparkline: FC<SparklineProps> = ({
    points,
    width = 72,
    height = 24,
    stroke = "currentColor"
}) => {
    if (points.length < 2) {
        return null;
    }

    const min = Math.min(...points);
    const max = Math.max(...points);
    const range = max - min || 1;
    const stepX = width / (points.length - 1);

    const coords = points.map((value, index) => {
        const x = index * stepX;
        const y = height - ((value - min) / range) * height;
        return `${x.toFixed(2)},${y.toFixed(2)}`;
    });

    const lastCoord = coords[coords.length - 1].split(",");

    return (
        <svg
            className="pi-sparkline"
            width={width}
            height={height}
            viewBox={`0 0 ${width} ${height}`}
            fill="none"
            aria-hidden="true"
        >
            <polyline
                points={coords.join(" ")}
                stroke={stroke}
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx={lastCoord[0]} cy={lastCoord[1]} r={2} fill={stroke} />
        </svg>
    );
};

export default Sparkline;
